(() => {
  // Containers in your theme
  const contentRoot = document.querySelector('#CollectionAjaxContent');
  const grid = contentRoot?.querySelector('.grid.grid--uniform');
  const pagination = document.querySelector('.pagination');
  const nextLinkEl = pagination?.querySelector('.next a');

  if (!contentRoot || !grid || !pagination || !nextLinkEl) return;

  // Add a tiny trigger after the pagination (kept in DOM for SEO)
  const trigger = document.createElement('div');
  trigger.id = 'infinite-scroll-trigger';
  pagination.after(trigger);

  // Hide native pagination once JS is active (kept in HTML)
  pagination.classList.add('is-hidden-by-infinite');

  let loading = false;
  let nextHref = nextLinkEl.getAttribute('href') || null;

  // Status text (a11y-friendly)
  const status = document.createElement('div');
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.className = 'infinite-status';
  trigger.after(status);
  const setStatus = (msg) => (status.textContent = msg || '');

  async function loadNextPage() {
    if (loading || !nextHref) return;
    loading = true;
    setStatus('Loading more products…');

    try {
      const res = await fetch(nextHref, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const html = await res.text();
      const tpl = document.createElement('template');
      tpl.innerHTML = html;

      // Find the same grid and pagination in the fetched page
      const nextDoc = tpl.content;
      const nextContentRoot = nextDoc.querySelector('#CollectionAjaxContent');
      const nextGrid = nextContentRoot?.querySelector('.grid.grid--uniform');
      const nextPagination = nextDoc.querySelector('.pagination');
      const nextLink = nextPagination?.querySelector('.next a');

      // Append new product tiles
      if (nextGrid) {
        nextGrid.querySelectorAll('.grid__item.grid-product').forEach((item) => {
          grid.appendChild(item);
        });
      }

      // Update nextHref for subsequent loads
      nextHref = nextLink ? nextLink.getAttribute('href') : null;

      if (!nextHref) {
        observer.disconnect();
        setStatus('All products loaded.');
        trigger.remove();
      }

    } catch (e) {
      console.error('[Infinite Scroll]', e);
      setStatus('Unable to load more products.');
    } finally {
      loading = false;
      if (status.textContent) setTimeout(() => setStatus(''), 1200);
    }
  }

  // Prefetch when close to the bottom
  const observer = new IntersectionObserver(
    (entries) => entries[0].isIntersecting && loadNextPage(),
    { rootMargin: '800px 0px 800px 0px' }
  );

  observer.observe(trigger);
})();
